import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Dots } from "react-activity";
import styled from "styled-components";

import Pagination from "@components/Pagination";
import { COLOR_WHITE } from "@static/COLORS";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  background: ${COLOR_WHITE};
  border-radius: 6px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const TableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1fr;
  width: 100%;
  background: #f6f6f6;
  padding: 8px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const ContainerScrollCell = styled.div`
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
`;

const TableCellContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1fr;
  width: 100%;
  padding: 0px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const TableHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: ${({ align = "start" }) => align};
`;

const TableCell = styled.div`
  font-size: 14px;
  padding: 12px 8px 12px 0px;
  text-align: ${({ align = "start" }) => align};
  word-break: break-all;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: ${COLOR_WHITE};
  border-radius: 6px;
`;

const ContainerPagination = styled.div`
  background: ${COLOR_WHITE};
  border-radius: 6px;
  width: 100%;
  height: 52px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 8px;
  box-sizing: border-box;
`;

// const Pagination = styled.div`
//   width: 100px;
//   background: red;
// `;

const LABEL_HEADER = [
  "Media Name",
  "Screen Name",
  "Start Date",
  "End Date",
  "Duration",
];
const { REACT_APP_API_MEDIA_LOG_ENDPOINT } = process.env;

export const TableDetails = ({
  dataList = [],
  setDataList = () => undefined,
  selectedDateRange,
  selectedScreens = null,
  selectedMedia = null,
  detailCurrentPage = 1,
  setDetailCurrentPage = () => undefined,
  detailTotalPage = 1,
  setDetailTotalPage = () => undefined,
}) => {
  const allCustomers = getUserExtraCustomers();
  const [isLoading, setIsLoading] = useState(false);

  const initial = async () => {
    try {
      setIsLoading(true);
      const resp = await axios({
        method: "post",
        url: `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/get-details-media-logs`,
        data: {
          startDate: selectedDateRange[0],
          endDate: selectedDateRange[1],
          deviceId: selectedScreens,
          mediaId: selectedMedia,
          page: detailCurrentPage,
          customerList: allCustomers,
        },
      });
      const respData = _.get(resp, ["data"]);
      console.log("respData :>> ", respData);
      if (_.get(respData, ["status"])) {
        const results = _.chain(respData).get(["result", "data"]).value();
        const totalPages = _.chain(respData)
          .get(["result", "pagination", "totalPages"])
          .value();
        const currentPage = _.chain(respData)
          .get(["result", "pagination", "currentPage"])
          .value();
        setDetailCurrentPage(currentPage);
        setDetailTotalPage(totalPages);
        setDataList(results);
      }
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initial();
  }, [detailCurrentPage]);

  const onHandleChangePage = ({ page = 1 }) => {
    setDetailCurrentPage(page);
  };

  return (
    <React.Fragment>
      <Container>
        {!isLoading ? (
          <React.Fragment>
            <TableHeaderContainer>
              {_.map(LABEL_HEADER, (item, index) => {
                const isCenter = _.includes([4, 5, 6], index);
                return (
                  <TableHeader
                    key={index}
                    align={isCenter ? "center" : "start"}
                  >
                    {item}
                  </TableHeader>
                );
              })}
            </TableHeaderContainer>
            <ContainerScrollCell>
              {_.map(dataList, (item, index) => {
                const rawStartDate = _.get(item, ["startTime"]);
                const sDate = dayjs
                  .unix(rawStartDate)
                  .format("DD/MM/YYYY hh:mm:ss");
                const rawEndDate = _.get(item, ["endTime"]);
                const eDate = dayjs
                  .unix(rawEndDate)
                  .format("DD/MM/YYYY hh:mm:ss");
                return (
                  <TableCellContainer
                    key={index}
                    style={{
                      borderBottom: "1px solid #f6f6f6",
                    }}
                  >
                    <TableCell>{_.get(item, ["media_name"])}</TableCell>
                    <TableCell>{_.get(item, ["device_name"])}</TableCell>
                    <TableCell>{sDate}</TableCell>
                    <TableCell>{eDate}</TableCell>
                    <TableCell align="center">
                      {_.get(item, ["duration"])}
                    </TableCell>
                  </TableCellContainer>
                );
              })}
            </ContainerScrollCell>
          </React.Fragment>
        ) : (
          <LoadingContainer>
            <Dots />
          </LoadingContainer>
        )}
      </Container>
      <ContainerPagination>
        <Pagination
          currentPage={detailCurrentPage}
          totalPage={detailTotalPage}
          onHandleChangePage={onHandleChangePage}
        />
      </ContainerPagination>
    </React.Fragment>
  );
};
